import { Reveal } from "./Reveal";
import { PILLARS } from "../lib/data";

export const About = () => {
  return (
    <section id="about" className="py-24 lg:py-36" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="text-xs font-semibold uppercase tracking-[0.25em] text-brand mb-8">About</p>
              <p className="font-display font-semibold text-3xl sm:text-4xl lg:text-[2.6rem] leading-[1.2] tracking-tight text-ink">
                I&rsquo;m a freelance designer & developer who turns ideas into{" "}
                <span className="text-gradient">soft, delightful products</span> — designed with care and hand-coded to perfection.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal delay={0.1}>
              <p className="text-xs font-semibold uppercase tracking-[0.25em] text-ink-soft mb-4">How I work</p>
            </Reveal>
            <div>
              {PILLARS.map((p, i) => (
                <Reveal key={p.no} delay={0.1 + i * 0.08}>
                  <div className="group py-8 border-t border-line flex gap-8 hover:pl-2 transition-[padding] duration-300">
                    <span className="font-display font-extrabold text-2xl text-gradient">{p.no}</span>
                    <div>
                      <h3 className="font-display font-semibold text-xl sm:text-2xl text-ink mb-2">{p.title}</h3>
                      <p className="text-ink-soft leading-relaxed font-light">{p.body}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
